<template>
  <div class="md-layout md-alignment-top-center">
    <div class="md-layout-item md-size-90">
      <button class="btn btn-lg btn-secondary btn-block" @click="clickShowHiddenItemBtn">{{showHiddenItemBtnStr}}</button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      isDisplayItem: Boolean,
    },
    computed: {
      showHiddenItemBtnStr() { return this.isDisplayItem ? '表示されていない商品を隠す' : '表示されていない商品を表示'; },
    },
    methods: {
      clickShowHiddenItemBtn() {
        this.$emit('clickShowHiddenItemBtn');
      },
    },
  };
</script>

<style scoped>
  .md-layout {
    margin-bottom: 1%;
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/ShowHiddenItemBtn.vue?2d85e2e2